import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutZoneSuperRegionLookup extends Layout {
    sourceZoneSuperRegion: DataSource;
    tableZoneRegionLookup: Table;
}
